export default __webpack_public_path__ + "static/media/download_disable.6242dd5d.svg";